import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { verticalSpace } from '@doltech/utils/lib/css-style';
import { isEmptySlateNodeValue } from '@doltech/utils/lib/editor';

import { useProgressListGrammar } from '../../hocs/progress-list-grammar';

const Container = styled.div`
  ${verticalSpace(16)}
`;

export const GapFillExplanations = observer((props: RenderElementProps) => {
  const { children, element, attributes } = props;
  const progressStore = useProgressListGrammar();
  const isEmpty = isEmptySlateNodeValue(element);

  if (!progressStore || !progressStore?.isShowResult || isEmpty) {
    return null;
  }

  return (
    <Container
      className="gap-fill-explanations"
      contentEditable={false}
      {...attributes}
    >
      {children}
    </Container>
  );
});
